"use strict";

import debounce from 'debounce';

export function initInScope($scope) {

    $scope.find('.js-navbar-toggle').on('click', function (e) {
        e.preventDefault();
        let $this = $(this);

        if ($this.hasClass('is-open')) {
            $this.removeClass('is-open');
            $('.navbar-collapse').removeClass('is-open');
            $('body').removeClass('open-overlay');

        } else {
            $this.addClass('is-open');
            $('.navbar-collapse').addClass('is-open');
            $('body').addClass('open-overlay');
        }
    });

    // Initialize subnav toggle immediately
    subnavToggle($scope);

    $(globalThis).on('load', debounce(() => {
        subnavToggle($scope);
    }, 200));

    $(document).ready(function () {
        // Store the globalThis width
        let windowWidth = $(globalThis).width();

        $(globalThis).on('resize', debounce(() => {
            // Check globalThis width has actually changed and it's not just iOS triggering a resize event on scroll
            if ($(globalThis).width() !== windowWidth) {
                // Update the globalThis width for next time
                windowWidth = $(globalThis).width();

                subnavToggle($scope);
            }
        }, 200));

        $("body").on("mouseenter", ".li-grid-display--js a, .li-grid-display--js p", function () {
            $(".li-grid-display__hover").removeClass("li-grid-display__hover");
            $(this).parent().addClass("li-grid-display__hover");
            let $nextItem = $(this).parent().next("li").find("div");

            // Falls die Klasse bereits existiert, warte 200ms bevor sie neu gesetzt wird
            if ($(".subnav-item__d-block").length) {
                let timeout = setTimeout(() => {
                    // Nur setzen, wenn die Maus nicht auf dem aktuellen Element ist
                    if (!$(".subnav-item__d-block:hover").length) {
                        $(".subnav-item__d-block").removeClass("subnav-item__d-block");
                        $nextItem.addClass("subnav-item__d-block");
                    }
                }, 300);

                // Falls die Maus während der Wartezeit auf dem vorhandenen Element bleibt, Timeout abbrechen
                $(".subnav-item__d-block").on("mouseenter", function () {
                    clearTimeout(timeout);
                });
            } else {
                // Falls die Klasse nicht existiert, direkt ausführen
                $(".subnav-item__d-block").removeClass("subnav-item__d-block");
                $nextItem.addClass("subnav-item__d-block");
            }
        });
        $("body").on("mouseleave", ".navbar-nav__subnav", function () {
            $(".subnav-item__d-block").removeClass("subnav-item__d-block");
        });
    });
}

function subnavToggle($scope) {
    const globalClickHandler = function(e) {
        
        let $target = $(e.target);
        let $subnavLink = $target.closest('.js-navbar-toggle__subnav');
        
        if ($subnavLink.length) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
            let $thisLi = $subnavLink.closest('li');
            
            $('.navbar-collapse').addClass('is-open');
            $('.js-navbar-toggle').addClass('is-open');
            $('body').addClass('open-overlay');

            if ($thisLi.hasClass('is-open')) {
                $thisLi.removeClass('is-open');
                $('.js-nav').removeClass('is-open');
            } else {
                $thisLi.addClass('is-open');
                $('.js-nav').addClass('is-open');
            }
            
            return false;
        }
    };
    
    // Remove any existing handlers from all possible locations
    $('body').off('click.navToggle');
    $('.js-navbar-toggle__subnav').off('click');
    document.removeEventListener('click', globalClickHandler, true);
    document.body.removeEventListener('click', globalClickHandler, true);
    globalThis.removeEventListener('click', globalClickHandler, true);
    
    if (matchMedia('(max-width: 1199px)').matches) {        
        document.addEventListener('click', globalClickHandler, true);
    } else {
        document.removeEventListener('click', globalClickHandler, true);
        document.body.removeEventListener('click', globalClickHandler, true);
        globalThis.removeEventListener('click', globalClickHandler, true);
    }
}